/* LIBRAIRIRES */
import React, { useState } from 'react';

/* FIREBASE */
import { auth, firestore } from '../../firebase';
import { getFirestore, doc, deleteDoc } from 'firebase/firestore';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* ICONS */
import bin from '../../Assets/Icons/bin-modal.svg';

/* LOADER */
import { Oval } from 'react-loader-spinner';

/* CSS */
import './ModalDeleteUser.css';

const ModalDeleteUser = ({ userId, setAlertMessage, setAlertSeverity, setOpenAlert, setRefreshUserList, refreshUserList }) => {

    const [isLoading, setIsLoading] = useState(false);
    const { setOpenModalDeleteUser, setUserId } = useUserContext();
    const db = getFirestore();

    const handleDeleteUser = async () => {
        setIsLoading(true);
        try {
            await deleteDoc(doc(db, 'users', userId));
            console.log('User supprime avec succes');
            setRefreshUserList(!refreshUserList);
            setOpenModalDeleteUser(false);
            setAlertSeverity("success");
            setAlertMessage("User supprime avec succes");
            setOpenAlert(true);
        } catch (error) {
            console.error('Error deleting user:', error);
            setAlertSeverity("error");
            setAlertMessage(error);
            setOpenAlert(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (

        <div className='delete-clients-modal' >
            <div className='delete-clients-modal--container' >
                <div className='delete-clients-modal__text'>
                    <h2 className='title-delete-modal' ><img src={bin} alt="suppression" /> Confirmer la suppression ?</h2>
                    <p>Attention si vous cliquez sur confirmer la suppression de la fiche client sera définitive</p>
                </div>
                <div className='delete-clients-modal__buttons'>
                    <button className='delete-clients-modal__buttons__cancel' onClick={() => setOpenModalDeleteUser(false)}>Annuler</button>
                    <button className='delete-clients-modal__buttons__confirm' onClick={handleDeleteUser}>
                    {
                        isLoading ?
                        <Oval
                            height={25}
                            width={25}
                            color="white"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#4fa94d"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                            />
                        :
                        'Confirmer'
                    }
                    </button>

                </div>
            </div>           
        </div>
    )
}

export default ModalDeleteUser;